document.addEventListener("DOMContentLoaded", () => {
  console.log("navigation-mobile.js: v10 - Smart Search Redirects")

  // --- Kernelemente ---
  const burgerMenuTrigger = document.getElementById("burger-menu-trigger")
  const navDrawer = document.getElementById("nav-drawer")
  const navOverlay = document.getElementById("nav-overlay")
  const closeBtn = document.getElementById("nav-close-btn")
  const searchInput = document.querySelector(
    '#mobile-search-container input[type="search"], #mobile-search-container input[type="text"]',
  )

  if (!burgerMenuTrigger || !navDrawer || !navOverlay || !searchInput) {
    console.error("Mobile Nav: Kernelemente fehlen.")
    return
  }

  const originalParent = navDrawer.parentNode

  // --- 1. SMART REDIRECTS KONFIGURATION ---
  // Hier definierst du die Suchbegriffe (kleingeschrieben!) und das Ziel.
  const searchRedirects = {
    // Retoure & Service
    "retoure": "https://return.nilo-hamburg.de",
    "rücksendung": "https://return.nilo-hamburg.de",
    "reklamation": "https://return.nilo-hamburg.de",
    "hilfe": "https://nilo-hamburg.de/pages/kontakt",
    "kontakt": "https://nilo-hamburg.de/pages/kontakt",
    
    // Allgemeine Kategorien
    "handyhülle": "https://nilo-hamburg.de/collections/handyhullen",
    "handyhüllen": "https://nilo-hamburg.de/collections/handyhullen",
    "hülle": "https://nilo-hamburg.de/collections/handyhullen",
    "case": "https://nilo-hamburg.de/collections/handyhullen",
    "handykette": "https://nilo-hamburg.de/collections/handybander",
    "band": "https://nilo-hamburg.de/collections/handybander",
    "magsafe": "https://nilo-hamburg.de/collections/handyhullen?filter.p.m.custom.hullen_kategorie=MagSafe",
    "handybander": "https://nilo-hamburg.de/collections/handybander?filter.v.option.karabiner+farbe=Gold",
    "handybänder": "https://nilo-hamburg.de/collections/handybander?filter.v.option.karabiner+farbe=Gold",
    "handyhullen": "https://nilo-hamburg.de/collections/handyhullen",
    
    // Spezielle Modelle (optional, falls jemand nur "iPhone 15" eingibt ohne Klick)
    "iphone 17": "https://nilo-hamburg.de/collections/iphone-17-handyhulle?filter.v.option.modell=IPhone+17",
    "iphone 16": "https://nilo-hamburg.de/collections/iphone-16-hulle?filter.v.option.modell=IPhone+16",
    "iphone 15": "https://nilo-hamburg.de/collections/iphone-15-hulle?filter.v.option.modell=IPhone+15",
    
    // ... hier kannst du beliebig erweitern
  }

  // --- Daten für die Modell-Ansicht (Navigation) ---
  const phoneModels = {
    apple: {
      "iPhone 17": [
        { name: "iPhone 17 Pro Max", url: "https://nilo-hamburg.de/collections/iphone-17-pro-max-handyhulle?filter.v.option.modell=IPhone+17+Pro+Max" },
        { name: "iPhone 17 Pro", url: "https://nilo-hamburg.de/collections/iphone-17-pro-handyhulle?filter.v.option.modell=IPhone+17+Pro" },
        { name: "iPhone 17", url: "https://nilo-hamburg.de/collections/iphone-17-handyhulle?filter.v.option.modell=IPhone+17" },
        { name: "iPhone 17 Air", url: "https://nilo-hamburg.de/collections/iphone-17-pro-handyhulle-kopie?filter.v.option.modell=IPhone+17+Air" }
      ],
      "iPhone 16": [
        { name: "iPhone 16 Pro Max", url: "https://nilo-hamburg.de/collections/iphone-16-pro-max?filter.v.option.modell=IPhone+16+Pro+Max" },
        { name: "iPhone 16 Pro", url: "https://nilo-hamburg.de/collections/iphone-16-pro?filter.v.option.modell=IPhone+16+Pro" },
        { name: "iPhone 16 Plus", url: "https://nilo-hamburg.de/collections/iphone-16-plus?filter.v.option.modell=IPhone+16+Plus" },
        { name: "iPhone 16", url: "https://nilo-hamburg.de/collections/iphone-16-hulle?filter.v.option.modell=IPhone+16" },
        { name: "iPhone 16e", url: "https://nilo-hamburg.de/collections/iphone-16e-hulle?filter.v.option.modell=IPhone+16e" }
      ],
      "iPhone 15": [
        { name: "iPhone 15 Pro Max", url: "https://nilo-hamburg.de/collections/iphone-15-pro-max-huelle?filter.v.option.modell=IPhone+15+Pro+Max" },
        { name: "iPhone 15 Pro", url: "https://nilo-hamburg.de/collections/iphone-15-pro-hulle?filter.v.option.modell=IPhone+15+Pro" },
        { name: "iPhone 15 Plus", url: "https://nilo-hamburg.de/collections/iphone-15-plus-hulle?filter.v.option.modell=IPhone+15+Plus" },
        { name: "iPhone 15", url: "https://nilo-hamburg.de/collections/iphone-15-hulle?filter.v.option.modell=IPhone+15" }
      ],
      "iPhone 14": ["iPhone 14 Pro Max", "iPhone 14 Pro", "iPhone 14 Plus", "iPhone 14"],
      "iPhone 13": ["iPhone 13 Pro Max", "iPhone 13 Pro", "iPhone 13 mini", "iPhone 13"],
      "iPhone 12": ["iPhone 12 Pro Max", "iPhone 12 Pro", "iPhone 12 mini", "iPhone 12"],
    },
    samsung: {
      "Galaxy S25": [
        { name: "Galaxy S25 Ultra", url: "https://nilo-hamburg.de/collections/samsung-s25-ultra-hulle?filter.v.option.modell=Samsung+S25+Ultra" },
        { name: "Galaxy S25+", url: "https://nilo-hamburg.de/collections/samsung-s25-plus-hulle?filter.v.option.modell=Samsung+S25+Plus" },
        { name: "Galaxy S25", url: "https://nilo-hamburg.de/collections/samsung-s25-hulle?filter.v.option.modell=Samsung+S25" }
      ],
      "Galaxy S24": [
        { name: "Galaxy S24 Ultra", url: "https://nilo-hamburg.de/collections/samsung-s24-ultra-hulle?filter.v.option.modell=Samsung+S24+Ultra" },
        { name: "Galaxy S24+", url: "https://nilo-hamburg.de/collections/samsung-s24-plus-hulle?filter.v.option.modell=Samsung+S24+Plus" },
        { name: "Galaxy S24", url: "https://nilo-hamburg.de/collections/samsung-s24-hulle?filter.v.option.modell=Samsung+S24" }
      ],
      "Galaxy S23": ["Galaxy S23 Ultra", "Galaxy S23+", "Galaxy S23", "Galaxy S23 FE"],
      "Galaxy S22": ["Galaxy S22 Ultra", "Galaxy S22+", "Galaxy S22"],
      "Galaxy S21": ["Galaxy S21 Ultra", "Galaxy S21+", "Galaxy S21", "Galaxy S21 FE"],
    },
  }

  // --- Navigation öffnen & schließen ---
  const openNav = () => {
    document.body.style.overflow = "hidden"
    document.body.appendChild(navOverlay)
    document.body.appendChild(navDrawer)
    setTimeout(() => {
      navDrawer.classList.add("is-open")
    }, 10)
  }

  const closeNav = () => {
    navDrawer.classList.remove("is-open")
    document.body.style.overflow = ""
    setTimeout(() => {
      if (originalParent) {
        originalParent.appendChild(navOverlay)
        originalParent.appendChild(navDrawer)
      }
      switchView("menu")
      searchInput.blur()
    }, 400)
  }

  // --- Ansichten-Wechsler ---
  const switchView = (viewName) => {
    const views = navDrawer.querySelectorAll(".nav-content")
    views.forEach((view) => {
      if (view.dataset.view === viewName) {
        view.classList.add("is-visible")
      } else {
        view.classList.remove("is-visible")
      }
    })
    navDrawer.dataset.currentView = viewName
  }

  // --- Modell-Ansicht generieren ---
  const populateModelsView = (brand) => {
    const container = document.getElementById("model-list-container")
    const title = document.getElementById("model-view-title")
    if (!container || !title) return

    const brandName = brand.charAt(0).toUpperCase() + brand.slice(1)
    title.textContent = `${brandName} Modelle`

    const modelsByBrand = phoneModels[brand]
    let html = '<ul class="nav-categories">'

    for (const series in modelsByBrand) {
      html += `
        <li class="nav-item has-submenu">
          <a href="#" class="nav-link">
            <span class="nav-name">${series}</span>
            <span class="nav-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg></span>
          </a>
          <div class="submenu-wrapper">
            <ul class="submenu">
              ${modelsByBrand[series]
                .map((item) => {
                  let name, url;
                  if (typeof item === 'object' && item !== null) {
                      name = item.name;
                      url = item.url;
                  } else {
                      name = item;
                      url = `/search?q=${encodeURIComponent(item)}`;
                  }
                  
                  return `
                    <li class="submenu-item">
                      <a href="${url}" class="submenu-link">${name}</a>
                    </li>
                  `;
                })
                .join("")}
            </ul>
          </div>
        </li>
      `
    }
    html += "</ul>"
    container.innerHTML = html
  }

  // --- Helper: Smart Search Execution ---
  const executeSmartSearch = (query, event) => {
    const normalizedQuery = query.toLowerCase().trim()
    
    // 1. Prüfen auf exakten Match in unserer Redirect Liste
    if (searchRedirects[normalizedQuery]) {
      if(event) event.preventDefault(); // Standard Formular-Submit verhindern
      window.location.href = searchRedirects[normalizedQuery]
      return true
    }
    return false
  }

  // --- Event Listeners ---
  burgerMenuTrigger.addEventListener("click", openNav)
  closeBtn?.addEventListener("click", closeNav)
  navOverlay.addEventListener("click", closeNav)

  // Such-Logik: Focus & Blur
  searchInput.addEventListener("focus", () => switchView("search"))
  searchInput.addEventListener("blur", (e) => {
    if (!navDrawer.contains(e.relatedTarget)) {
      switchView("menu")
    }
  })

  // Such-Logik: ENTER Taste abfangen
  searchInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      // Wir übergeben das Event 'e', damit wir preventDefault machen können
      executeSmartSearch(searchInput.value, e)
    }
  })

  // Falls es einen "Suche Absenden" Button gibt (Lupe)
  // Optional: Wenn dein Input in einem Formular ist, wird beim Submit auch das Keydown Event oft reichen,
  // aber sicherheitshalber:
  const searchForm = searchInput.closest('form');
  if (searchForm) {
      searchForm.addEventListener('submit', (e) => {
          const wasRedirected = executeSmartSearch(searchInput.value, e);
          // Wenn weitergeleitet wurde, ist e.preventDefault() schon in der Funktion passiert.
      });
  }

  // Delegiertes Event-Handling für alle Klicks im Drawer
  navDrawer.addEventListener("click", (e) => {
    const target = e.target

    // Zurück-Buttons
    const backBtn = target.closest(".nav-back-btn")
    if (backBtn) {
      e.preventDefault()
      const targetView = backBtn.dataset.targetView
      if (targetView) {
        switchView(targetView)
      }
      return
    }

    // Modell-Trigger (Apple, Samsung)
    const modelTrigger = target.closest(".model-trigger")
    if (modelTrigger) {
      e.preventDefault()
      const brand = modelTrigger.dataset.brand
      if (brand) {
        populateModelsView(brand)
        switchView("models")
      }
      return
    }

    // Accordion-Logik (für alle Ebenen)
    const accordionHeader = target.closest(".nav-item.has-submenu > .nav-link")
    if (accordionHeader) {
      e.preventDefault()
      accordionHeader.parentElement.classList.toggle("is-open")
      return
    }
  })

  // Initialzustand
  switchView("menu")
})